<template>
  <div>
  <div class="container" v-if="!this.isMobile">
    <div class="inner bg-white">
      <div class="row wcc">
        <div class="col-12">
          <flash-message class="myCustomClass" v-if="cardDetailFlash"></flash-message>
          <loading :active.sync="isLoading" :can-cancel="true"></loading>

          <div class="row align-items-center">
            <div class="col-12">
              <div class="radialProgressBar progress-75">
                <div class="overlay">3 of 4</div>
              </div>

              <ul class="check-info">
                <li>
                  <span class="icon-invoicing"></span> Invoicing
                </li>
                <li>
                  <span class="icon-delivery"></span> Delivery
                </li>
                <li class="active">
                  <span class="icon-payment"></span> Payment
                </li>
                <li>
                  <span class="icon-order"></span> Order Complete
                </li>
              </ul>
            </div>
          </div>

          <p class="lg-text text-blue mb-1">The Health & Safety Group Ltd</p>
          <p class="lg-text">
            <span class="text-blue">Amount</span>
            £{{ cartPrice }}
          </p>
        </div>

        <div class="col-8">
        <form id="WPApaymentForm">
            <input
              id="sessionState"
              type="hidden"
              name="sessionState"
              v-model="user.sessionState"
            />
            <div class="card default mt-15">
              <div class="card-header">Cardholder details</div>
              <div class="card-body">
                <span id="paymentErrors"></span>
                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Name on card:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input
                      class="form-control"
                      type="text"
                      data-worldpay="name"
                      name="name"
                      v-model="user.Nameoncard"
                      placeholder="Name on card"
                      autocomplete="cc-name"
                    />
                  </div>
                </div>

                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Card Number:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <section id="card-pan" class="form-control"></section>
                  </div>
                </div>

                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Card Expiry:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-3">
                    <section id="card-expiry" class="form-control"></section>
                  </div>
                </div>

                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Cvv:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-3">
                    <section id="card-cvv" class="form-control"></section>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Full name:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input class="form-control" type="text" name="field1" v-model="user.first_name" autocomplete="name"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    *
                    <u>Billing address</u>
                    <span class="asterisk"></span>
                  </label>
                  <div class="col-lg-9"></div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Address 1:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input class="form-control" type="text" name="field1" v-model="user.address_1" autocomplete="address-line1"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">Address 2:</label>
                  <div class="col-lg-9">
                    <input class="form-control" type="text" name="field1" v-model="user.address_2" autocomplete="address-line2"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">Address 3:</label>
                  <div class="col-lg-9">
                    <input class="form-control" type="text" name="field1" v-model="user.address_3" autocomplete="address-line3"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Town:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input class="form-control" type="text" name="field1" v-model="user.town" autocomplete="address-level2"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Postcode/ZIP code:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input class="form-control" type="text" name="field1" v-model="user.postcode" autocomplete="postal-code"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Country:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <select
                      class="form-control"
                      size="0"
                      id="country-code"
                      v-model="user.country_id"
                      data-worldpay="country-code"
                    >
                      <option v-if="getcountry" v-for="item in getcountry"  :value="item.id">{{item.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">Telephone</label>
                  <div class="col-lg-9">
                    <input
                      class="form-control"
                      type="text"
                      name="field1"
                      v-model="user.mobile_phone"
                      autocomplete="tel"
                    />
                  </div>
                </div>
              </div>
            </div>
            <flash-message class="myCustomClass" v-if="cardValidationFlash"></flash-message>
            <div class="card default mt-15 hide">
              <div class="card-header">Cardholder validation</div>
              <div class="card-body">
                <p>Please complete this challenge to prove you are a real person:</p>
                <div id="recaptcha_element"></div>
                <div v-if="recaptcha" class="captcha">Please verify recaptcha</div>
              </div>
            </div>
            <div id="paypal-button-container" v-if="paypal_direct ==true"></div>
            <div id="paymentErrors" style="display:none;color:red;"></div>
            <div v-if="paypal_direct !=true">
              <button class="pull-right mt-15 submit btn-success btn" id="wpsubmit" type="button" disabled>Buy now</button>
          </div>
          </form>
        </div>
      </div>
      <!-- Payment Failure Popup -->
      <div v-if="showFailure" class="failure-overlay" @click.self="hideFailurePopup">
        <div class="failure-card">
          <div class="failure-icon">
            <svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="10" y="16" width="52" height="36" rx="6" fill="#f5f5f5" stroke="#e74c3c" stroke-width="2"/>
              <rect x="10" y="24" width="52" height="8" fill="#e74c3c" opacity="0.25"/>
              <rect x="16" y="38" width="20" height="3" rx="1.5" fill="#e0e0e0"/>
              <rect x="16" y="44" width="12" height="3" rx="1.5" fill="#e0e0e0"/>
              <circle cx="24" cy="56" r="12" fill="#e74c3c"/>
              <path d="M19.5 51.5L28.5 60.5M28.5 51.5L19.5 60.5" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
            </svg>
          </div>
          <h2 class="failure-heading">Sorry we couldn't process your payment.</h2>
          <p class="failure-intro">There was an error as follows:</p>
          <div class="failure-details">
            <div v-if="failureData.refusalCode"><span class="failure-label">Error code: </span><span class="failure-value-error">{{ failureData.refusalCode }}</span></div>
            <div v-if="failureData.refusalDescription"><span class="failure-label">Reason: </span><span class="failure-value">{{ failureData.refusalDescription }}</span></div>
            <div><span class="failure-label">HSG reference: </span><span class="failure-value">{{ failureHsgRef }}</span></div>
            <div v-if="failureData.amount"><span class="failure-label">Amount: </span><span class="failure-value">£{{ failureFormattedAmount }}</span></div>
          </div>
          <p class="failure-retry-note">Please use the button below to try again or use an alternative payment method.</p>
          <button class="failure-retry-btn" @click="retryPayment">Retry Payment</button>
          <p class="failure-help">We're here to help if you need it.</p>
          <p class="failure-brand">The Health &amp; Safety Group</p>
        </div>
      </div>

      <div class="col-12 mt-15 align-items-center" v-show="!showChallenge">
        <p class="lg-text">
          <a style="color:#212529;" @click="reload()">
            Start again
            <img
              alt="start-again"
              style="margin-top:-3px;"
              src="../images/worldpay/startagain.gif"
            />
          </a>
        </p>
      </div>

      <div class="col-12 mt-15 align-items-center" v-show="!showChallenge">
        <p class="lg-text">
          <a style="color:#212529; cursor:pointer;" @click="goBack()">
            Back
            <img alt="cancel" style="margin-top:-3px;" src="../images/worldpay/cancel.gif" />
          </a>
        </p>
      </div>
    </div>
  </div>
  <div class="container py-30 inner bg-white" v-else>
    <flash-message class="myCustomClass" v-if="cardDetailFlash"></flash-message>
    <loading :active.sync="isLoading" :can-cancel="true"></loading>
    <div class="row mb-15 title-row">
      <div class="col-10">
        <h2>Checkout Process</h2>
      </div>
      <div class="col-2 inner">
        <a class="toggle visible-xs">
          <div class="mob-col d-block d-md-none" style="position: relative">
            <div id="nav-open-basket" @click="this.showNav"></div>
          </div>
        </a>
      </div>
    </div>
    <div class="row align-items-center mt-30">
      <div class="col-12">
        <div class="radialProgressBar progress-75">
          <div class="overlay">3 of 4</div>
        </div>

        <ul class="check-info">
          <li class="active">
            <span class="icon-payment"></span> Payment
          </li>
        </ul>
        <span class="next">Next: Order Complete</span>
      </div>
    </div>

    <!-- invoice -->
    <div class="invoice">
      <!-- cart -->
      <div class="row cart mb-15">
        <div class="col-12">
          <div class="border">
            <div class="row">
              <div class="col-12">
                <p>Please review your purchase details, then select a payment method to continue.</p>
                <p>
                  <span class="hl font-weight-normal">The Health & Safety Group Ltd</span>
                </p>
                <p>
                  <span class="hl">Amount</span>
                  £{{cartPrice}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- cart -->

      <div class="row">
        <div class="col-12 mb-15">
          <form id="WPApaymentForm">
            <input
              id="apm-name"
              type="hidden"
              data-worldpay="apm-name"
              name="apm-name"
              value="paypal"
            />
            <div class="card">
              <div class="card-header">Cardholder details</div>
              <span id="paymentErrors"></span>

              <div class="card-body p-15 text-left">
                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Name on card:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input
                      type="text"
                      data-worldpay="name"
                      name="name"
                      v-model="user.Nameoncard"
                      class="form-control"
                      autocomplete="cc-name"
                      placeholder="Name on card"
                    />
                  </div>
                </div>

                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Card Number:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <section id="card-pan" class="form-control"></section>
                  </div>
                </div>

                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Card Expiry Date:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-6">
                    <section id="card-expiry" class="form-control"></section>
                  </div>
                </div>
                <div class="form-group row" v-if="payment_type !='PAYPAL'">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Cvv:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <section id="card-cvv" class="form-control"></section>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Full name:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input type="text" name="field1" class="form-control" v-model="user.first_name" autocomplete="name"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    *
                    <u>Billing address</u>
                    <span class="asterisk"></span>
                  </label>
                  <div class="col-lg-9"></div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Address 1:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input type="text" name="field1" class="form-control" v-model="user.address_1" autocomplete="address-line1"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">Address 2:</label>
                  <div class="col-lg-9">
                    <input type="text" name="field1" class="form-control" v-model="user.address_2" autocomplete="address-line2"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">Address 3:</label>
                  <div class="col-lg-9">
                    <input type="text" name="field1" class="form-control" v-model="user.address_3" autocomplete="address-line3"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Town:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input type="text" name="field1" class="form-control" v-model="user.town" autocomplete="address-level2"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Postcode/ZIP code:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <input type="text" name="field1" class="form-control" v-model="user.postcode" autocomplete="postal-code"/>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">
                    Country:
                    <span class="asterisk">*</span>
                  </label>
                  <div class="col-lg-9">
                    <select
                      size="0"
                      id="country-code"
                      data-worldpay="country-code"
                      class="form-control"
                      v-model="user.country_id"
                    >
                      
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-lg-3 col-form-label form-control-label">Telephone</label>
                  <div class="col-lg-9">
                    <input
                      type="text"
                      name="field1"
                      class="form-control"
                      v-model="user.mobile_phone"
                      autocomplete="tel"
                    />
                  </div>
                </div>
                <div v-if="paypal_direct !=true">
                  <button class="submit pull-right btn-success btn" id="wpsubmit" type="button">Buy now</button>
                </div>
                <div id="paypal-button-container" v-if="paypal_direct ==true"></div>
              </div>
            </div>
          </form>
        </div>

        <div class="col-12">
          <a href="#">
            <img alt="brand" src="https://staging.onsite-safety.co.uk/images/worldpay/brand.gif" />
          </a>
          <br />
          <br />
          <span>
            <p style="font-size:13px;">For help with your payment visit the: WorldPay Help.</p>
          </span>
        </div>

        <div class="col-12 align-items-center">
          <p class="lg-text">
            <a style="color: rgb(33, 37, 41);">
              Start again
              <img
                alt="start-again"
                src="data:image/gif;base64,R0lGODlhFQATALMAAP///+/v79/f38zMzL6+vqWlpY+Pj4CAgHFxcWZmZlBQUEFBQTMzMyAgIBAQEAAAACH5BAQUAP8ALAAAAAAVABMAAAR6EMhJq70404GWR4MmBchjno8SZAFzOktyKA+zXuWJTI2ZXALUwzEpnEKVg89gKgRWCdOusmgCXIrEAkAwbakmAkDI9VqqDzH60Sg/vpTcb9BrhOSWrgkpkAxOBRdrB30CBw4mDBgCiEIvSBd0jmyQGQYuiQY3IpydGhEAOw=="
                style="margin-top: -3px;"
              />
            </a>
          </p>
          <p class="lg-text">
            <a style="color:#212529;" @click="goBack()">
              Back
              <img
                alt="cancel"
                style="margin-top:-3px;"
                src="https://staging.onsite-safety.co.uk/images/worldpay/cancel.gif"
              />
            </a>
          </p>
        </div>
      </div>
    </div>
    <div class="m-basket-bottom">
      <pageBottom></pageBottom>
    </div>
  </div>
   <!-- DDC hidden iframe container -->
  <div id="ddc-container" style="display:none;"></div>

  <!-- 3DS Challenge container -->
  <div id="challenge-container" v-show="showChallenge" class="challenge-container">
  </div>
  </div>
</template>
<script>
import Vue from "vue";
require('vue-flash-message/dist/vue-flash-message.min.css');
import Vuelidate from 'vuelidate';
import VueFlashMessage from 'vue-flash-message';
Vue.use(Vuelidate);
Vue.use(VueFlashMessage);
import Helper from "../../helper.js";
import pageBottom from "./pageBottom.vue";
import CheckoutApi from "@/services/Checkout";
import Users from "@/services/Users";
import Payment from "@/services/Payment";
import Orders from "@/services/Orders";
import { loadScript } from "vue-plugin-load-script";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import UserMixin from "../mixins/UserMixin";
export default {
  name: "checkout",
  mixins: [Helper,UserMixin],
  props: ["id"],
  data() {
    return {
      submitted: false,
      isLoading: true,
      isShowing: false,
      orderId: false,
      invoiceNumber: false,
      paypal_direct:false,
      paypal_order_id:null,
      tokens: "",
      payment_type: "",
      payment_type_src: "",
      getcountry:[],
      cart: this.$store.state.cart,
      consignee: {
        isDataEmpty: "",
        first_name: "",
        last_name: "",
        town: "",
        postcode: "",
        phone: "",
        country_id: "GB",
        customer_id: this.$store.state.auth.customer_id
      },
      user: [],
      recaptcha: false,
      cartPrice:
        localStorage.getItem("trainingCoursePrice") != null
          ? localStorage.getItem("trainingCoursePrice")
          : localStorage.getItem("totalPrice"),
      trainingItem: {},
      courseItem: {},
      cardDetailFlash: true,
      cardValidationFlash: false,
      // KEV-748: New Worldpay v2 flow state
      showChallenge: false,
      showFailure: false,
      failureData: {},
      transactionReference: '',
      supply3dsDeviceDataUrl: '',
      collectionReference: '',
      checkoutInstance: null,
      isFormValid: false,
      isSubmitting: false
    };
  },
  computed: {
    failureHsgRef() {
      var d = this.failureData;
      var orderCode = d.customerOrderCode || '—';
      var transRef = d.transId || d.transactionReference || '';
      return transRef ? (orderCode + ' (' + transRef + ')') : orderCode;
    },
    failureFormattedAmount() {
      if (this.failureData.amount === undefined || this.failureData.amount === null) return '';
      var num = parseFloat(String(this.failureData.amount).replace(/[^0-9.-]/g, ''));
      return isNaN(num) ? '' : num.toFixed(2);
    }
  },
  validations: {
    consignee: {
      first_name: { required },
      last_name: { required },
      address_1: { required },
      town: { required },
      postcode: { required },
      phone: { required },
      country_id: { required }
    }
  },
  components: {
    Loading,
    pageBottom
  },
  watch: {
    showChallenge(active) {
      if (active) {
        document.body.classList.add('challenge-fullscreen');
      } else {
        document.body.classList.remove('challenge-fullscreen');
      }
    }
  },
  beforeDestroy() {
    // Clean up body class
    document.body.classList.remove('challenge-fullscreen');
    // Clean up any message listeners
    if (this._ddcMessageHandler) {
      window.removeEventListener('message', this._ddcMessageHandler);
    }
    if (this._challengeMessageHandler) {
      window.removeEventListener('message', this._challengeMessageHandler);
    }
  },
  beforeMount() {
    var _this = this;
    this.paypal_direct = _this.$route.params.id === 'PAYPALDIRECT'?true:false;
    // let recaptchaScript = document.createElement("script");
    if(this.paypal_direct == true){
      
      loadScript("https://www.paypal.com/sdk/js?client-id="+process.env.VUE_APP_PAYPAL_CLIENT_ID+"&currency=GBP").then(() => {
        var pporderid;
        paypal.Buttons({
          style: {
              layout: 'horizontal',
              tagline: false
          },
          onCancel: function(){
            _this.isLoading = false;
          },
          createOrder: async function(data, actions) {
            if(localStorage.getItem("trainingCoursePrice") != null){
              let data = await _this.paypalSubmitCourseItem(_this);
              _this.paypal_order_id = data.id
              return data.id
            }else{
              let data = await _this.paypalSubmitItem(_this);
              _this.paypal_order_id = data.id
              return data.id
            }
          },
          // Finalize the transaction
          onApprove: async function(data, actions) {
              //Change to capturePaymentForOrder if you want to capture the funds immediatly
              if(_this.orderId && _this.paypal_order_id){
                await Payment.paypalPaymentCapture(_this.orderId,_this.paypal_order_id,_this.cartPrice)
                .then(resp => {
                  if (resp.data.success) {
                    var store = _this.$store;
                    var route = _this.$router;
                    for (let item of store.state.cart) {
                      store.commit("confirm", item);
                    }
                    _this.isLoading = false;
                    let mesg = 'failed';
                    if(resp.data.order.payment_status == 'Paid'){
                      mesg = 'success';
                    }
                    route.push({name:"confirm",query:{message:mesg}});
                  } else {
                    _this.isLoading = false;
                    _this.flash("Payment Failure.", "error", {
                      timeout: 4000
                    });
                  }
                  _this.removeCache();
                })
                .catch(error => {
                  _this.isLoading = false;
                });
              } 
              
          }
      }).render('#paypal-button-container');
            console.log('notification mounted');
        
    });
    }
  },
  mounted() {
    var _this = this;
    window.localStorage.removeItem("confirm");
    _this.$store.state.confirm = [];
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      $("#nav").hide();
      $("#body").removeClass("mob-bg");
    }
    if(localStorage.getItem("trainingCourse") != null) {
      
      this.trainingItem = JSON.parse(localStorage.getItem('bookingdata'));
      this.courseItem = JSON.parse(localStorage.getItem('coursebookingdata'));
      this.trainingCourse = localStorage.getItem('trainingCourse');
      this.trainingPrice = this.courseItem.fee;
      
      this.payment_type = this.$route.params.id === 'PAYPALDIRECT'?'PAYPAL':this.$route.params.id;
      
      this.getCountryList();
      
      this.fetchUserDetails();
    } else {
      if (!this.$store.state.auth) {
        this.$router.replace(this.$route.query.redirect || "/");
      }
      this.payment_type = this.$route.params.id === 'PAYPALDIRECT'?'PAYPAL':this.$route.params.id;
      this.isLoading = true;
      if (this.$store.state.cart.length > 0) {        
        this.getCountryList();
        
        this.fetchUserDetails();
      } else {
        _this.flash("Cart is empty.", "alert", {
          timeout: 2000
        });
        _this.$router.replace(_this.$route.query.redirect || "/basket");
      }
    }
    if(this.$route.params.id != 'PAYPALDIRECT'){
      if(typeof window.Worldpay != 'undefined' && typeof window.Worldpay.checkout != 'undefined' ){
        window.location.reload();
      }
      loadScript(process.env.VUE_APP_WPA_DOMAIN+"/access-checkout/v2/checkout.js").then(() =>{
        this.initialiseWPACheckout();
      });
    }
  },
  methods: {
    callGrecaptcha() {
      grecaptcha.render("recaptcha_element", {
        sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY
      });
    },
    goBack() {
      this.$router.back();
    },
    getImgUrl(pic) {
      if (pic) {
        return require("../images/worldpay/" + pic + ".gif");
      }
    },
    getImgUrlBUY(pic) {
      if (pic === "PAYPAL") {
        return "https://www.paypalobjects.com/webstatic/en_US/i/buttons/buy-logo-medium.png";
      } else {
        return require("../images/worldpay/lgmake_payment.jpg");
      }
    },
    reload() {
      window.location.reload();
    },
    getCountryList(){
      Orders.getcountry()
        .then(request => {
          if (request.data) {
            this.getcountry = request.data.data;
          }
        })
        .catch(error => {
          this.flash("You are offline Connect to network.", "info", {
            timeout: 2000
          });
          this.isLoading = false;
        });
    },
    setCustomerIdInAuth(customer_id, authData) {
      authData.customer_id = customer_id;
      this.$store.commit('auth', JSON.stringify(authData));
      localStorage.customer_id = JSON.stringify(authData);
    },
    submitCourseItem() {
      var _this = this;
      var authData  = JSON.parse(this.$store.state.auth);
      var customerId  = JSON.parse(this.$store.state.auth).customer_id;
      var hcrUserData = this.getLocalStoragUser();
      this.isLoading = true;
      let courseItem = {
        email: this.trainingItem.email,
        product_descriptor_id: this.courseItem.item.descriptor_id,
        fee_per_person: this.courseItem.fee,
        training_course_id: localStorage.getItem("courseId"),
        first_name: this.trainingItem.firstName,
        last_name: this.trainingItem.lastName,
        company_name: this.trainingItem.company,
        phone: this.trainingItem.mobile
      };

      if ( !JSON.parse(this.$store.state.auth).customer_id ){
        courseItem.hcr_user_id = JSON.parse(this.$store.state.auth).hcr_user_id;
        
        if (hcrUserData)
          courseItem.hcr_user_data = JSON.stringify(hcrUserData);
      }
      Orders.placeCourseOrder(courseItem)
        .then(res => {
          if(!customerId && res.data.customer_id && courseItem.email === ˇ.email) {
            _this.setCustomerIdInAuth(res.data.customer_id, authData);
            customerId = res.data.customer_id;
          }
          if (res.data) {
            _this.orderId = res.data.id;
            _this.authorizePayment();
          }
        })
        .catch(error => {
          console.log('error', error);
          _this.isLoading = false;
          _this.isSubmitting = false;
        });
    },
    submitItem() {
      var _this = this;
      var authData  = JSON.parse(this.$store.state.auth);
      var customerId  = JSON.parse(this.$store.state.auth).customer_id;
      var hcrUserData = this.getLocalStoragUser();
      var consigneeData = this.getLocalStoragConsignee();
      this.isLoading = true;
      let paid_price = 0;
      let retail_price = 0;
      let cart = [];

      for (let item of this.$store.state.cart) {
        if (item.actual_price) {
          paid_price = parseFloat(item.actual_price);
          retail_price = parseFloat(item.item.retail_price);
        } else {
          paid_price = parseFloat(item.item.retail_price);
          retail_price = parseFloat(item.item.retail_price);
        }

        cart.push({
          product_id: item.item.id,
          paid_price: paid_price,
          retail_price: retail_price,
          quantity: item.quantity
        });
      }
      Orders.plceorder(customerId, cart, hcrUserData, consigneeData)
        .then(res => {
          if (res.data) {
            if(!customerId && res.data.customer_id) {
              _this.setCustomerIdInAuth(res.data.customer_id, authData);
              customerId = res.data.customer_id;
            }
            _this.orderId = res.data.id;
            _this.invoiceNumber = res.data.invoice_number;
            _this.authorizePayment();
          }
        })
        .catch(error => {
          _this.isLoading = false;
          _this.isSubmitting = false;
          _this.showWPError('Failed to process the payment. Please contact us for support.',_this);
        });
    },
    removeCache() {
      localStorage.removeItem("trainingCourse");
      localStorage.removeItem("trainingCoursePrice");
    },
    loader(res) {},

    paypalSubmitCourseItem: (_this) => {    
      var authData  = JSON.parse(_this.$store.state.auth);
      var customerId  = JSON.parse(_this.$store.state.auth).customer_id;
      var shipping = JSON.stringify(_this.user);
      var hcrUserData = _this.getLocalStoragUser();
      var store = _this.$store;
      _this.isLoading = true;
      let total = 0;
      let subtotal = 0;
      let vat = 0;
      let paid_price = 0;
      let retail_price = 0;
      var paytotal = _this.cartPrice;
      parseFloat(total) + parseFloat(subtotal) + parseFloat(vat);
      let cart = [];
      let courseItem = {
        email: _this.trainingItem.email,
        product_descriptor_id: _this.courseItem.item.descriptor_id,
        fee_per_person: _this.courseItem.fee,
        training_course_id: localStorage.getItem("courseId"),
        first_name: _this.trainingItem.firstName,
        last_name: _this.trainingItem.lastName,
        company_name: _this.trainingItem.company,
        phone: _this.trainingItem.mobile
      };

      if ( !JSON.parse(store.state.auth).customer_id ){
        courseItem.hcr_user_id = JSON.parse(store.state.auth).hcr_user_id;

      if (hcrUserData)
          courseItem.hcr_user_data = JSON.stringify(hcrUserData);
      }
      let order_req = Orders.placeCourseOrder(courseItem);
      let paypal_req = order_req.then(res => {
        if(!customerId && res.data.customer_id && courseItem.email === hcrUserData.email) {
          _this.setCustomerIdInAuth(res.data.customer_id, authData);
          customerId = res.data.customer_id;
        }
        if (res.data) {
          _this.orderId = res.data.id;
          return Payment.paypalPayment(
            shipping,
            customerId,
            res.data.id,
            token,
            paytotal
          );
          
        }
      })
      .catch(error => {
        console.log('error', error);
        _this.isLoading = false;
      });
      return paypal_req.then(respo => {
        if(respo.data){
          return respo.data;
        }
      })
      .catch(error => {
        console.log('error', error);
        _this.isLoading = false;
      });
    //return;
    },
    paypalSubmitItem: (_this) => {
      var authData  = JSON.parse(_this.$store.state.auth);
      var customerId  = JSON.parse(_this.$store.state.auth).customer_id;
      var hcrUserData = _this.getLocalStoragUser();
      var consigneeData = _this.getLocalStoragConsignee();
      var shipping = JSON.stringify(_this.user);
      var store = _this.$store;
      _this.isLoading = true;
      let total = 0;
      let subtotal = 0;
      let vat = 0;
      let paid_price = 0;
      let retail_price = 0;
      var paytotal = _this.cartPrice;
      parseFloat(total) + parseFloat(subtotal) + parseFloat(vat);
      let cart = [];
      for (let item of store.state.cart) {
        if (item.actual_price) {
          paid_price = parseFloat(item.actual_price);
          retail_price = parseFloat(item.item.retail_price);
        } else {
          paid_price = parseFloat(item.item.retail_price);
          retail_price = parseFloat(item.item.retail_price);
        }

        cart.push({
          product_id: item.item.id,
          paid_price: paid_price,
          retail_price: retail_price,
          quantity: item.quantity
        });
      }
      _this.isLoading = true;
      let order_req = Orders.plceorder(customerId, cart, hcrUserData, consigneeData);
      let paypal_req = order_req.then(res => {
        if (res.data) {
          if(!customerId && res.data.customer_id) {
            _this.setCustomerIdInAuth(res.data.customer_id, authData);
            customerId = res.data.customer_id;
          }
          _this.orderId = res.data.id;
          _this.invoiceNumber = res.data.invoice_number;
          return Payment.paypalPayment(
            shipping,
            customerId,
            res.data.id,
            paytotal
          );            
        }
      })
      
      .catch(error => {
        _this.isLoading = false;
      });
      return paypal_req.then(respo => {
        if(respo.data){
          return respo.data;
        }
      })
      .catch(error => {
        _this.isLoading = false;
      });
    },
    showWPError(message,_this){
       _this.isLoading = false;
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        _this.flash(message, "error", {timeout: 4000});
        var submitButton = document.getElementById('wpsubmit');
        if (submitButton) submitButton.disabled = false;
        _this.isSubmitting = false;
    },
    initialiseWPACheckout() {
      var _this = this;
      const merchantIdentity = process.env.VUE_APP_WPA_CHECKOUT_ID;
      var submitButton = document.getElementById("wpsubmit");
      var form = document.getElementById("WPApaymentForm");
      var errorMessageDiv = document.getElementById('paymentErrors');

      if (!form) return;

      // Listen for card brand changes (block Amex)
      form.addEventListener('wp:card-brands:change', function (event) {
        var brands = event.detail.brands || [];
        var isAmex = brands.includes('amex') || brands.includes('american-express');
        if (errorMessageDiv) {
          errorMessageDiv.textContent = isAmex ? 'American Express is not accepted. Please use Visa or Mastercard.' : '';
          errorMessageDiv.style.display = isAmex ? 'inline-block' : 'none';
        }
      });

      Worldpay.checkout.init(
        {
          id: merchantIdentity,
          form: "#WPApaymentForm",
          fields: {
            pan: {
              selector: "#card-pan",
              placeholder: "Card number"
            },
            expiry: {
              selector: "#card-expiry",
              placeholder: "MM/YY"
            },
            cvv: {
              selector: "#card-cvv",
              placeholder: "CVV"
            }
          },
          styles: {
            "input": {
              "color": "black",
              "font-weight": "normal",
              "font-size": "15px",
              "letter-spacing": "normal"
            },
            "input.is-valid": {
              "color": "green"
            },
            "input.is-invalid": {
              "color": "red"
            },
            "input.is-onfocus": {
              "color": "black"
            }
          },
          accessibility: {
            ariaLabel: {
              pan: "Card number input",
              expiry: "Expiry date input",
              cvv: "CVV security code input"
            },
            lang: { locale: "en-GB" },
            title: {
              enabled: true,
              pan: "Card number",
              expiry: "Expiry date",
              cvv: "Security code"
            }
          },
          acceptedCardBrands: ["mastercard", "visa"],
          enablePanFormatting: true
        },
        function (error, checkout) {
          if (error) {
            console.error('Worldpay init failed:', error);
            _this.showWPError('Failed to initialise the Payment.', _this);
            return;
          }
          _this.checkoutInstance = checkout;
        }
      );

      // Listen for form validity changes
      form.addEventListener('wp:form:change', function (e) {
        _this.isFormValid = e.detail['is-valid'];
        submitButton.disabled = !_this.isFormValid;
      });

      // Submit button handler
      submitButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (_this.isSubmitting || !_this.isFormValid || !_this.checkoutInstance) return;
        _this.isSubmitting = true;
        submitButton.disabled = true;
        _this.isLoading = true;

        _this.checkoutInstance.generateSessionState(function (error, sessionState) {
          if (error) {
            console.error('Session state generation failed:', error);
            _this.isSubmitting = false;
            submitButton.disabled = false;
            _this.isLoading = false;
            _this.showWPError('The payment form is invalid or incomplete', _this);
            return;
          }
          _this.user.sessionState = sessionState;
          // Place order first, then authorize payment
          localStorage.getItem("trainingCoursePrice") != null
            ? _this.submitCourseItem()
            : _this.submitItem();
        });
      });
    },

    // ── KEV-748: New Worldpay v2 in-page payment flow ─────────────

    authorizePayment() {
      var _this = this;
      var shipping = JSON.stringify(this.user);
      var customerId = JSON.parse(this.$store.state.auth).customer_id;
      var email = this.getLocalStoragUser() ? this.getLocalStoragUser().email : '';

      const post = new FormData();
      post.append('Nameoncard', this.user.Nameoncard || '');
      post.append('name', this.user.first_name || '');
      post.append('grandTotal', this.cartPrice);
      post.append('address1', this.user.address_1 || '');
      post.append('address2', this.user.address_2 || '');
      post.append('address3', this.user.address_3 || '');
      post.append('postcode', this.user.postcode || '');
      post.append('telephoneNumber', this.user.mobile_phone || '');
      post.append('countryCode', this.user.country_id || '');
      post.append('billingAddress', this.user.first_name || '');
      post.append('Total', this.cartPrice);
      post.append('orderId', this.orderId);
      post.append('sessionState', this.user.sessionState);
      post.append('invoiceNumber', this.invoiceNumber);
      post.append('city', this.user.town || '');
      post.append('returnUrl', process.env.VUE_APP_API_BASE_URL + '/worldpay/3ds-return');
      post.append('email', email);
      post.append('paymentType', 'Card');

      Payment.authorizePayment(post)
        .then(resp => {

          console.log('Payment authorize response1:', resp);
          if (resp && resp.data) {
            var data = resp.data;
            if (data.transactionReference) {
              _this.transactionReference = data.transactionReference;
            }
            if ('outcome' in data && '3dsDeviceDataRequired' == data.outcome && 'deviceDataCollection' in data) {
              console.log('DDC data received:', data);
              // DDC data received — proceed with 3DS
              _this.handleThreeDS(data);
            } else if (data.paymentStatus === 'FAILURE') {
              _this.showFailurePopup(data);
            } else {
              _this.showWPError('Unexpected response from payment server.', _this);
            }
          } else {
            _this.showWPError('Failed to process the payment. Please contact us for support.', _this);
          }
        })
        .catch(error => {
          console.error('Payment authorize error:', error);
          _this.showFailurePopup({
            customerOrderCode: _this.orderId,
            refusalCode: 'ERR-101',
            transId: _this.transactionReference,
            refusalDescription: 'Unable to reach payment server. Please try again.'
          });
        });
    },

    handleThreeDS(data) {
      var _this = this;
      var ddc = data.deviceDataCollection;
      _this.supply3dsDeviceDataUrl = data._actions.supply3dsDeviceData.href;

      // Create hidden iframe for Device Data Collection
      var ddcContainer = document.getElementById('ddc-container');
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.name = 'ddcIframe';
      ddcContainer.appendChild(iframe);

      // Create form targeting the DDC iframe
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = ddc.url;
      form.target = 'ddcIframe';

      var jwtInput = document.createElement('input');
      jwtInput.type = 'hidden';
      jwtInput.name = 'JWT';
      jwtInput.value = ddc.jwt;

      var binInput = document.createElement('input');
      binInput.type = 'hidden';
      binInput.name = 'Bin';
      binInput.value = ddc.bin;

      form.appendChild(jwtInput);
      form.appendChild(binInput);
      document.body.appendChild(form);

      // Small delay ensures the iframe is ready before submit
      setTimeout(function () { form.submit(); }, 1000);

      // Listen for DDC completion message
      this._ddcMessageHandler = function (event) {
        try {
          var msg = JSON.parse(event.data);
          if (msg.MessageType === 'profile.completed') {
            window.removeEventListener('message', _this._ddcMessageHandler);
            _this.collectionReference = msg.SessionId;
            _this.supply3DSChallenge();
          }
        } catch (e) {
          // Non-JSON messages from other origins — safely ignored
        }
      };
      window.addEventListener('message', this._ddcMessageHandler);
    },

    supply3DSChallenge() {
      var _this = this;

      const post = new FormData();
      post.append('transaction_reference', this.transactionReference);
      post.append('grandTotal', this.cartPrice);
      post.append('MessageType', 'profile.completed');
      post.append('SessionId', this.collectionReference);
      post.append('user-agent', navigator.userAgent);
      post.append('actionUrl', this.supply3dsDeviceDataUrl);
      post.append('orderID', this.orderId);

      Payment.supply3dsDeviceData(post)
        .then(resp => {
          console.log('Payment supply3dsDeviceData response1:', resp);
          if (resp && resp.data) {
            var data = resp.data;
            if ('outcome' in data && data.outcome === '3dsChallenged') {
              // 3DS challenge required
              _this.renderChallenge(data);
            } else if ('success' in data && 'order' in data && data.order.payment_status === 'Paid') {
              _this.handlePaymentSuccess(data);
            } else if (data.paymentStatus === 'FAILURE') {
              _this.showFailurePopup(data);
            } else {
              _this.showWPError('Unexpected response during 3DS verification.', _this);
            }
          } else {
            _this.showWPError('Failed to process 3DS verification.', _this);
          }
        })
        .catch(error => {
          console.error('Supply 3DS error:', error);
          _this.showFailurePopup({
            customerOrderCode: _this.orderId,
            refusalCode: 'ERR-102',
            transId: _this.transactionReference,
            refusalDescription: 'Unable to reach payment server during 3DS check. Please try again.'
          });
        });
    },

    renderChallenge(response) {
      var _this = this;
      var challenge = response.challenge;

      // Show challenge container, hide payment form
      this.showChallenge = true;

      var challengeContainer = document.getElementById('challenge-container');

      var iframe = document.createElement('iframe');
      iframe.name = 'challengeIframe';
      iframe.id = 'challengeIframe';
      iframe.allow = 'web-share';
      challengeContainer.appendChild(iframe);

      var form = document.createElement('form');
      form.method = 'POST';
      form.id = 'challengeForm';
      form.action = challenge.url;
      form.target = 'challengeIframe';

      var jwtInput = document.createElement('input');
      jwtInput.type = 'hidden';
      jwtInput.name = 'JWT';
      jwtInput.value = challenge.jwt;

      form.appendChild(jwtInput);
      document.body.appendChild(form);
      const parent_origin = process.env.VUE_APP_API_BASE_URL;
      // Small delay ensures the iframe is ready before submit
      setTimeout(function () { form.submit(); }, 1000);


      // Listen for challenge completion message
      this._challengeMessageHandler = function (message) {
        try {
          if(message.origin !== parent_origin) {
            console.log('Cross-origin message:', message);
            return;
          }
          var data = JSON.parse(message.data);
          if ('TransactionId' in data) {
            _this.showChallenge = false;
            window.removeEventListener('message', _this._challengeMessageHandler);
            _this.isLoading = true;
            data.challenge_url = response._actions.complete3dsChallenge.href;
            data.transactionReference = _this.transactionReference;
            _this.completeChallenge(data);
          }
        } catch (e) {
          // Non-JSON or cross-origin messages — safely ignored
          console.error(e);
        }
      };
      window.addEventListener('message', this._challengeMessageHandler);

      // Hide loader once challenge iframe is shown
      setTimeout(function () { _this.isLoading = false; }, 1000);
    },

    completeChallenge(challengeData) {
      console.log('Challenge data:', challengeData);
      var _this = this;

      const post = new FormData();
      post.append('transaction_reference', this.transactionReference);
      post.append('grandTotal', this.cartPrice);
      post.append('orderID', this.orderId);
      for(const key in challengeData) {
        post.append(key, challengeData[key]);
      }

      Payment.completeChallenge(post)
        .then(resp => {
          if (resp && resp.data) {
            var data = resp.data;
            if ('success' in data && 'order' in data && data.order.payment_status === 'Paid') {
              _this.handlePaymentSuccess(data);
            } else if (data.paymentStatus === 'FAILURE') {
              _this.showFailurePopup(data);
            }else {
              _this.showWPError('Payment verification failed. Please try again.', _this);
            }
          } else {
            _this.showWPError('Failed to complete payment verification.', _this);
          }
        })
        .catch(error => {
          console.error('Complete challenge error:', error);
          _this.showFailurePopup({
            customerOrderCode: _this.orderId,
            refusalCode: 'ERR-103',
            transId: _this.transactionReference,
            refusalDescription: 'Unable to reach payment server while completing 3DS challenge. Please try again.'
          });
        });
    },

    handlePaymentSuccess(data) {
      var store = this.$store;
      var route = this.$router;
      for (let item of store.state.cart) {
        store.commit('confirm', item);
      }
      this.isLoading = false;
      let mesg = 'failed';
      if (data.order.payment_status === 'Paid') {
        mesg = 'success';
      }
      route.push({ name: 'confirm', query: { message: mesg } });
    },

    showFailurePopup(data) {
      this.isLoading = false;
      this.isSubmitting = false;
      this.showChallenge = false;
      this.failureData = data || {};
      this.showFailure = true;
      var submitButton = document.getElementById('wpsubmit');
      if (submitButton) submitButton.disabled = false;
    },

    hideFailurePopup() {
      this.showFailure = false;
      this.failureData = {};
    },

    retryPayment() {
      this.hideFailurePopup();
      window.location.reload();
    }
  }
};
</script>
<style lang="scss" scoped>
.hide{
  display: none;
}
.basket {
  background-color: white;
  padding: 61px 0;
  .pad-top {
    padding: 20px;
  }
  .empty-content {
    width: 100%;
    padding: 15px;
    float: left;
    border-radius: 5px;
    .dur {
      width: 100%;

      background: #f7f9fe;
      border: 1px solid #cdd3e3;
      border-radius: 7px;
      margin: 102px 0;
      p {
        font-size: 22px;
        padding: 20px;
        margin: 0;
      }
    }
  }
  .basket-content {
    display: none;
  }
  .rgt-content {
    width: 100%;
    padding: 15px;
    float: left;
    border-radius: 5px;
    margin-bottom: 15px;
    background-color: white;
  }
  .table-main {
    width: 100%;
    border: 0;
    display: inline-block;
  }
  .table-curved {
    border-collapse: collapse;
    border: 0 solid #cdd3e3;
    border-radius: 6px;
    border-left: 0;
    border-right: 1px solid #dee2e6;
    th {
      background: #f7f9fe;
      padding: 6px 10px 6px 13px;
      border: 1px solid #cdd3e3;
      background: #f7f9fe none repeat scroll 0 0;
      font-size: 15px;
      border-right: 0 none !important;
      border-bottom: 1px solid #cdd3e3 !important;
    }
    th:first-child {
      border-radius: 6px 0 0 0;
    }
    tr.bt-bdr td {
      padding: 6px 10px 6px 13px;
    }
    td {
      background: #fff;
      font-size: 14px;
      border-right: 0 none !important;
      border-top: 0 !important;
      padding: 6px 10px 6px 13px;
      .qty-btn {
        width: 70%;
        float: left;
        margin-top: 5px;
        .remove {
          font: normal 14px Arial, Helvetica, sans-serif;
          color: #b8452a;
          text-decoration: none;
          border: 0;
          background-color: white;
        }
      }
      .qty-div {
        width: 30%;
        float: left;
        .qty {
          background: #f7f7f7;
          border: 1px solid #e3e3e3;
          color: #72675f;
          padding: 2px 3px;
          text-align: center;
          width: 23px;
          margin-right: 5px;
          height: 22px;
          display: inline-block;
          border-radius: 4px;
          margin-top: 3px;
        }
      }
      .total-a {
        font-size: 20px;
        font-weight: 700;
      }
    }
    .bt-btn {
      width: 218px;
      display: inline-block;
      padding: 15px 0 13px;
      outline: none;
      .tbl-btn {
        width: 195px;
        text-align: center;
        display: inline-block;
        padding: 8px 0;
        color: #fff;
        font-size: 15px;
        font-weight: 700;
        background: #2ba245;
        transition: all 0.8s ease;
        border: 0;
        border-radius: 35px;
        outline: none;
      }
    }

    .cal {
      border-top: 0 !important;
      border-bottom: 0;
    }
    .total-bill {
      border-top: 1px solid #dee2e6;
      .bt-txt,
      .bt-or {
        display: inline-block;
        font: normal 20px Arial, Helvetica, sans-serif;
        color: #888686;
        padding: 15px 0 13px;
        outline: none;
      }
    }
  }
  tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  .cart {
    .cart-col {
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
      padding-right: 15px;
      padding-left: 15px;
    }
  }
}
#paymentErrors {
  color: red;
}
.captcha {
  color: red;
}
#paypal-button-container{
  width: 200px;
  float: right;
  margin-top: 5px;
}
@media (max-width: 575px) {
  #paypal-button-container{
    width: 100%;
  }
  .basket {
    padding: 1px 0px;
  }
  .btns-wrap {
    padding: 15px;
    padding-top: 5px;
    padding-bottom: 0;
    .btn {
      margin-bottom: 15px;
    }
  }
  .cart {
    .cart-col {
      flex: 0 0 100% !important;
      max-width: 100% !important;
      padding-right: 15px !important;
      padding-left: 15px !important;
    }
    p {
      font-size: 16px;
      margin-bottom: 4px;
    }
    .m-txt {
      margin-left: 5px;
      margin-right: 8px;
      border: 1px solid #8c8c89;
      text-align: center;
      width: 40px;
    }
  }
  .btn-pri-display {
    display: none;
  }
  .m-checkout-wrap {
    width: 100%;
    .btn-pri {
      width: 100%;
      background: #40a535;
      border-radius: 0;
      color: #ffffff !important;
      padding: 15px 15px;
      margin-top: 10px;
    }
  }
  .title-row {
    margin-top: 20px;
    h2 {
      font-size: 20px;
    }
  }
  #nav-open-basket {
    width: 35px;
    height: 35px;
    border: 2px solid #000000;
    border-radius: 50px;
    background-image: url("../images/menu-black.png");
    //bottom: 0px;
    right: 8px;
    position: absolute;
  }
}

/* KEV-748: Challenge container + Failure popup */
.challenge-container {
  display: flex;
  flex-direction: column;
  min-height: 70vh;
  width: 100%;
}
.challenge-container iframe {
  border: none;
  flex-grow: 1;
  width: 100%;
  min-height: 500px;
}
</style>

<!-- Unscoped styles: fullscreen challenge hides all other body content -->
<style>
body.challenge-fullscreen .challenge-container {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 99999;
  background: #fff;
  display: flex !important;
  flex-direction: column;
  min-height: 100vh !important;
}
body.challenge-fullscreen .challenge-container iframe {
  flex-grow: 1;
  width: 100% !important;
  height: 100% !important;
  min-height: 100vh !important;
}

.failure-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.failure-card {
  background: #fff;
  border-radius: 12px;
  padding: 36px 32px 28px;
  max-width: 430px;
  width: 92%;
  text-align: center;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
}
.failure-icon svg {
  width: 72px;
  height: 72px;
  margin-bottom: 14px;
}
.failure-heading {
  font-size: 20px;
  font-weight: 700;
  color: #1e1e1e;
  margin-bottom: 6px;
}
.failure-intro {
  font-size: 14px;
  color: #555;
  margin-bottom: 16px;
}
.failure-details {
  text-align: left;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 18px;
}
.failure-details > div {
  margin-bottom: 4px;
}
.failure-label {
  font-weight: 600;
  color: #333;
}
.failure-value {
  color: #555;
}
.failure-value-error {
  color: #e74c3c;
  font-weight: 600;
}
.failure-retry-note {
  font-size: 13px;
  color: #666;
  margin-bottom: 16px;
}
.failure-retry-btn {
  display: inline-block;
  background: #f8b233;
  color: #fff;
  font-weight: 700;
  border: none;
  border-radius: 6px;
  padding: 12px 36px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.2s;
  margin-bottom: 14px;
}
.failure-retry-btn:hover {
  background: #e5a020;
}
.failure-help {
  font-size: 12px;
  color: #999;
  margin-bottom: 2px;
}
.failure-brand {
  font-size: 12px;
  color: #999;
  font-weight: 600;
}
</style>